import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let userinfo = localStorage.getItem('userinfo')
if (userinfo) {
  userinfo = JSON.parse(userinfo)
}
const store = new Vuex.Store({
  state: {
    userinfo: userinfo
  },
  getters: {
    userinfo: function (state) {
      return state.userinfo
    }
  },
  mutations: {
    login(state, payload = {}) {
      state.userinfo = payload
    },
    logout(state) {
      state.userinfo = null
    }
  },
  actions: {
    login({ commit }, payload) {
      commit("login", payload)
    },
    logout({ commit }) {
      commit('logout')
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/js/store/index.js